import script from "./FrmRepairPartsCreatePart.vue?vue&type=script&setup=true&lang=js"
export * from "./FrmRepairPartsCreatePart.vue?vue&type=script&setup=true&lang=js"

import "./FrmRepairPartsCreatePart.vue?vue&type=style&index=0&id=2cc0375a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc0375a"]])

export default __exports__